__turbopack_context__.v({
  "language": "LanguageSwitcher-module-scss-module__vo1EPa__language",
  "language-switcher": "LanguageSwitcher-module-scss-module__vo1EPa__language-switcher",
});
